import { HUsdSection } from '@/components/dashboard/HUsdSection'

export function HUsdPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <HUsdSection />
    </div>
  )
}
